import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    getCommInventory(id, invtDate = '') {
        let deliveryDate = '';
        if (invtDate !== '') {
            deliveryDate = `/inventorydate/${invtDate}`;
        }
        return API.get(`getcomminventory/locationid/${id}${deliveryDate}`).then(res => (res.data));
    },
    getDistributionData(id) {
        return API.get(`getcommdistribution/commid/${id}`).then(res => (res.data));
    },
    addCommissaryBatch(formdata) {
        return API.post('addcommissarybatch', httpBuildQuery(formdata)).then(res => (res.data));
    },
};
